// extracted by mini-css-extract-plugin
module.exports = {"forgotLink":"login_forgotLink__n1Jtl","loadingIndicator":"login_loadingIndicator__QlVFt","notificationStyle":"login_notificationStyle__OoUYf"};